module.exports = __webpack_public_path__ + "media/images/landing/dno/product-5-24268e378be300412e65d663b09558b7.png";